import { Menu } from 'antd'
import * as React from 'react'

import { DropdownButton, Icon } from '@lmc/ui-kit'
import { ConsentType } from '@lmc/common/types'
import styled from 'styled-components'

type AddConsentDropdownButtonProps = {
  addConsentForm: () => void
  addCapacityForm: () => void
  localisation: {
    addConsentForm: string
    addCapacityForm: string
  }
  setConsentType: (e: ConsentType) => void
  testId?: string
}

export default function AddConsentDropdownButton({
  addConsentForm,
  addCapacityForm,
  localisation,
  setConsentType,
  testId,
}: AddConsentDropdownButtonProps): React.ReactElement {
  const DropdownButtonStyled = styled(DropdownButton)`
    .ant-dropdown-menu-title-content {
      :hover {
        color: ${({ theme }) => theme.palette.pink};
      }
    }
  `

  return (
    <DropdownButtonStyled
      buttonText="Add Consent"
      testId={testId}
      overlay={
        <div>
          <Menu style={styles.menu}>
            <Menu.Item
              id="add-consent"
              onClick={() => {
                setConsentType('consent')
                addConsentForm()
              }}
            >
              <div style={styles.dropdownOption}>
                <Icon name="PlusOutlined" size={12} />
                <div style={styles.dropdownOptionText}>
                  {localisation.addConsentForm}
                </div>
              </div>
            </Menu.Item>
            <Menu.Item
              id="add-capacity"
              onClick={() => {
                setConsentType('lackOfCapacity')
                addCapacityForm()
              }}
            >
              <div style={styles.dropdownOption}>
                <Icon name="PlusOutlined" size={12} />
                <div style={styles.dropdownOptionText}>
                  {localisation.addCapacityForm}
                </div>
              </div>
            </Menu.Item>
          </Menu>
        </div>
      }
      style={styles.dropdownBtnContainer}
      type="primary"
    />
  )
}

const styles = {
  dropdownBtnContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  dropdownOption: {
    display: 'flex',
    alignItems: 'center',
    margin: 5,
  },
  dropdownOptionText: {
    fontSize: 12,
    marginLeft: 5,
  },
  menu: {
    borderRadius: 4,
    boxShadow:
      '0 1px 3px hsla(0, 0%, 0%, 0.05), 0 2px 4px hsla(0,0%,0%,0.05), 0 -1px 3px hsla(0, 0%, 0%, 0.05), 0 -2px 4px hsla(0,0%,0%,0.05)',
  },
}
